// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/NumberSeries.yaml
// Generated: 2026-01-10T11:16:26.651Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateNumberSeries, UpdateNumberSeries, NumberSeries } from '@/types/core/NumberSeries';

/**
 * NumberSeries Service
 * CRUD operations for NumberSeries via the ABP API.
 */
export const numberSeriesService = new EntityService<NumberSeries, CreateNumberSeries, UpdateNumberSeries>(
  '/api/core/numberseries',
  'NumberSeries',
);
